var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    { attrs: { "max-width": "560" } },
    [
      _c("w-card-title", [_vm._v(_vm._s(_vm.$ct("sidebar.add-block")))]),
      _c(
        "w-card-content",
        { style: { padding: 0 } },
        [
          _c(
            "w-list",
            [
              _vm.templates.length > 0
                ? [
                    _c("w-list-subheader", [
                      _vm._v(_vm._s(_vm.$ct("sidebar.templates"))),
                    ]),
                    _vm._l(_vm.templates, function (tpl) {
                      return _c(
                        "w-list-item",
                        {
                          key: "tpl-" + tpl.key,
                          staticClass: "block-option",
                          on: {
                            click: function ($event) {
                              return _vm.$emit("add-template", tpl)
                            },
                          },
                        },
                        [
                          _c(
                            "w-list-item-icon",
                            [_c("w-fa", { attrs: { icon: "magic" } })],
                            1
                          ),
                          _c("w-list-item-text", [
                            _c("div", { staticClass: "block-name" }, [
                              _vm._v(_vm._s(_vm.getTemplateName(tpl.key))),
                            ]),
                            _c("div", { staticClass: "block-description" }, [
                              _vm._v(
                                _vm._s(tpl.blocks.map(_vm.getName).join(", "))
                              ),
                            ]),
                          ]),
                        ],
                        1
                      )
                    }),
                  ]
                : _vm._e(),
              _c("w-list-subheader", [
                _vm._v(_vm._s(_vm.$ct("sidebar.custom-blocks"))),
              ]),
              _c(
                "w-list-item",
                {
                  staticClass: "block-option",
                  on: {
                    click: function ($event) {
                      return _vm.add(_vm.fieldsBlockKey)
                    },
                  },
                },
                [
                  _c(
                    "w-list-item-icon",
                    [_c("w-fa", { attrs: { icon: "th-list" } })],
                    1
                  ),
                  _c("w-list-item-text", [
                    _c("div", { staticClass: "block-name" }, [
                      _vm._v(_vm._s(_vm.$ct("sidebar.fields-block"))),
                    ]),
                    _c("div", { staticClass: "block-description" }, [
                      _vm._v(
                        _vm._s(_vm.$ct("sidebar.fields-block-description"))
                      ),
                    ]),
                  ]),
                ],
                1
              ),
              _vm.definitions.length > 0
                ? [
                    _c("w-list-subheader", [
                      _vm._v(_vm._s(_vm.$ct("sidebar.predefined-blocks"))),
                    ]),
                    _vm._l(_vm.definitions, function (def) {
                      return _c(
                        "w-list-item",
                        {
                          key: def.key,
                          staticClass: "block-option",
                          on: {
                            click: function ($event) {
                              return _vm.add(def.key)
                            },
                          },
                        },
                        [
                          _c(
                            "w-list-item-icon",
                            [_c("w-fa", { attrs: { icon: def.icon } })],
                            1
                          ),
                          _c("w-list-item-text", [
                            _c("div", { staticClass: "block-name" }, [
                              _vm._v(_vm._s(_vm.getName(def.key))),
                            ]),
                            _c("div", { staticClass: "block-description" }, [
                              _vm._v(_vm._s(_vm.getDescription(def.key))),
                            ]),
                          ]),
                        ],
                        1
                      )
                    }),
                  ]
                : _vm._e(),
            ],
            2
          ),
        ],
        1
      ),
      _c(
        "w-card-actions",
        [
          _c(
            "w-button",
            {
              staticClass: "cancel",
              attrs: { icon: "ban" },
              on: {
                click: function ($event) {
                  return _vm.$emit("close")
                },
              },
            },
            [_vm._v(_vm._s(_vm.$t("common.cancel")))]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }